// * Offline queue for error reports
import {sendReportToServer} from './reporter';

const KEY = "error_reports_queue_v1";

export function enqueueLocalReport(payload) {
    const q = JSON.parse(localStorage.getItem(KEY) || "[]");
    q.push(payload);
    localStorage.setItem(KEY, JSON.stringify(q));
}


export async function flushQueue() {
    const q = JSON.parse(localStorage.getItem(KEY) || "[]");
    const remaining = [];
    for (const item of q) {
        try {
            await sendReportToServer(item);
        } catch (err) {
            remaining.push(item);
        }
    }
    localStorage.setItem(KEY, JSON.stringify(remaining));
}